import React from "react";
export default function TheCompetitiveEdge() {
  return <section id="patients" className="w-full bg-[#fafaf8] px-6 py-24 md:px-16">
      <div className="mx-auto grid max-w-7xl items-center gap-16 md:grid-cols-2">
        <div>
          <span className="mb-4 inline-block text-xs font-bold uppercase tracking-[0.14em] text-[#028090]">
            For Patients
          </span>

          <h2 className="mb-6 font-serif text-4xl leading-tight text-[#0a2540] md:text-6xl">
            Your health keeps
            <br />
            getting pushed back.
            <br />
            <em className="text-[#028090]">Not anymore.</em>
          </h2>

          <p className="mb-10 max-w-xl text-lg leading-8 text-[#4a5f6b]">
            Whether you&apos;re managing care for someone else or just struggling
            to find time for yourself — KolayHealth notices when you&apos;re overdue
            and makes booking the next step effortless.
          </p>

          <div className="grid gap-4 md:grid-cols-2">
            <div className="rounded-2xl border border-[rgba(2,128,144,0.1)] bg-white p-6">
              <div className="mb-3 text-2xl"></div>
              <h4 className="mb-2 font-serif text-lg text-[#0a2540]">
                Proactive reminders
              </h4>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                We track when preventive care is due based on guidelines — not
                your medical records.
              </p>
            </div>

            <div className="rounded-2xl border border-[rgba(2,128,144,0.1)] bg-white p-6">
              <div className="mb-3 text-2xl"></div>
              <h4 className="mb-2 font-serif text-lg text-[#0a2540]">
                Calendar-smart booking
              </h4>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                Slots suggested around your existing schedule, with drive time
                and insurance already checked.
              </p>
            </div>

            <div className="rounded-2xl border border-[rgba(2,128,144,0.1)] bg-white p-6">
              <div className="mb-3 text-2xl"></div>
              <h4 className="mb-2 font-serif text-lg text-[#0a2540]">
                Privacy by design
              </h4>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                We never access your medical records. Scheduling works on open
                availability, not patient data.
              </p>
            </div>

            <div className="rounded-2xl border border-[rgba(2,128,144,0.1)] bg-white p-6">
              <div className="mb-3 text-2xl">✓</div>
              <h4 className="mb-2 font-serif text-lg text-[#0a2540]">
                One tap. Done.
              </h4>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                No login portals, no hold music, no forms. Appointment
                confirmed in seconds.
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-[24px] border border-[rgba(2,128,144,0.1)] bg-white p-8 shadow-[0_16px_60px_rgba(10,37,64,0.06)]">
          <p className="mb-6 font-serif text-2xl italic leading-10 text-[#0a2540]">
            “She&apos;s busy, her schedule is packed, and her mammogram has been
            overdue for over a year. She knows she should book it — she just
            hasn&apos;t had a free moment to figure it out.”
          </p>

          <div className="mb-8 flex items-center gap-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#028090] to-[#02C39A] text-xl text-white">
              
            </div>
            <div>
              <div className="font-semibold text-[#0a2540]">
                Meet Jane — a KolayHealth user
              </div>
              <div className="text-sm text-[#8aa0aa]">
                Patient · Works full time
              </div>
            </div>
          </div>

          <div className="border-t border-[rgba(2,128,144,0.1)] pt-6">
            <div className="mb-4 flex items-start gap-3">
              <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#e0f5f3] text-xs font-bold text-[#028090]">
                1
              </div>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                <strong className="text-[#0a2540]">A notification arrives</strong>{" "}
                — &quot;You&apos;re overdue for your mammogram. Tap to see a slot near
                you.&quot;
              </p>
            </div>

            <div className="mb-4 flex items-start gap-3">
              <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#e0f5f3] text-xs font-bold text-[#028090]">
                2
              </div>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                <strong className="text-[#0a2540]">A match is ready</strong> —
                nearby, fits her afternoon, $0 copay, already on her insurance.
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#e0f5f3] text-xs font-bold text-[#028090]">
                3
              </div>
              <p className="text-sm leading-7 text-[#4a5f6b]">
                <strong className="text-[#0a2540]">She taps once.</strong>{" "}
                Booked. Calendar updated. Reminder set. Done.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}